export default __webpack_public_path__ + "static/media/SchoolStreet400.77e84102.jpg";